<div class="form-group" #formGroupRef>
    <label *ngIf="label" class="col-sm-8 control-label capitalize-first-letter">
        {{ label }}<span *ngIf="ngRequired">*</span>
    </label>
    <div [ngClass]="{'col-sm-40' : label, 'col-sm-48 inner-l-mini': !label }">
        <div class="form-check form-check-inline" *ngFor="let checkbox of options">
            <input class="form-check-input"
                   type="checkbox"
                   [name]="checkbox.name"
                   [attr.id]="checkbox.name | monRemoveWhiteSpace"
                   [checked]="isChecked(checkbox)"
                   (change)="toggleSelection(checkbox)"
                   (blur)="onInputBlur()">
            <label class="form-check-label" [attr.for]="checkbox.name | monRemoveWhiteSpace">
                {{ checkbox.name }}
            </label>
        </div>
        <span class="form-text text-muted">{{ helpTxt }}</span>
    </div>
</div>
